
import {
  defineComponent,
  reactive,
  toRefs,
  computed,
  onMounted,
  watch,
} from 'vue'
import tmRulePopup from '../common/popup/tm-rule-popup.vue'
import tmLoginPopup from '../common/popup/tm-login-popup.vue'
import tmReceiveSuccessPopup from '../common/popup/tm-receive-success-popup.vue'
import tmReceiveRedPacketPopup from '../common/popup/tm-receive-red-packet-popup.vue'
import tmForwardPopup from '../common/popup/tm-forward-popup.vue'
import { getXunJiaInfo3Cookie } from '@/composables/use-cookie-function'
import { Toast } from 'vant'
import { useStore } from 'vuex'
import {
  countAd,
  fetchDrawLottery,
  fetchAddDrawTimes,
} from '@/http/api'
import { useRoute } from 'vue-router'
export default defineComponent({
  name: '',
  components: {
    tmRulePopup,
    tmLoginPopup,
    tmReceiveSuccessPopup,
    tmReceiveRedPacketPopup,
    tmForwardPopup,
  },
  setup() {
    const route = useRoute()
    const store = useStore()
    const data = reactive({
      isShowTmRulePopup: false, // 规则弹窗控制
      isShowTmLoginPopup: false, // 登录弹窗控制
      isShowTmReceiveSuccessPopup: false, // 领取成功弹窗控制
      isShowReceiveRedPacketPopup: false, // 领取红包留资弹窗控制
      isShowTmForWardPopup: false, // 转发弹窗控制
      clipboard: new window.ClipboardJS('.forward-btn'),
      shareCon: '', // 分享文案+链接
      browserEnv: computed(() => store.state.browserEnv),
      appLoginCookieKey: computed(() => store.state.appLoginCookieKey),
      gameInfo: computed(() => store.state.gameInfo),
      gameLoginStatus: computed(() => store.state.gameLoginStatus),
      prizeList: computed(() => store.state.prizeList),
      prizeList1: [] as any,
      prizeList2: [] as any,
      prizeList3: [] as any,
      lotteryResult: computed(() => store.state.lotteryResult),
      lotteryIndex: computed(() => store.state.lotteryIndex),
      lotteryResultBO: {
        amount: '',
        code: 0,
        msg: '',
        remainPlayCount: 0,
      } as any,

      // ---------动画相关数据 s-------
      idxs: [] as any,
      height: 29.33333,
      y1: 0,
      y2: -29.33333,
      y3: -58.6666,
      prizeIndex: -1,
      speed: 1,
      speed1: 4, // 4vw
      speed2: 4,
      speed3: 4,
      slowSpeed: 0.5,
      playDefaultCircle: 4, // 奖品列表循环次数
      y1Circle: 0,
      y2Circle: 0,
      y3Circle: 0,
      timer1: null as any,
      timer2: null as any,
      timer3: null as any,
      timer22: null as any,
      timer33: null as any,
      overTimer: null as any,
      isDrawing: false, // 防止频繁点击抽奖
      isJoinPrize: false,
      isJoinPrize1: false,
      isJoinPrize2: false,
      isJoinPrize3: false,
      isOver: false,
      isOver1: false,
      isOver2: true,
      isOver3: true,
      // ---------动画相关数据 e-------
    })
    // 防止无缝轮播出现空白
    watch(
      () => [data.y1, data.y2, data.y3],
      nVal => {
        let maxY = -data.height * (data.prizeList.length - 1)
        let minY = -data.height * data.prizeList.length

        if (nVal[0] >= minY && nVal[0] <= maxY && !data.isJoinPrize1) {
          data.prizeList1 = [...data.prizeList1, data.prizeList1[0]]
          data.isJoinPrize1 = true
        } else if (
          (nVal[0] < minY || nVal[0] > maxY) &&
          data.isJoinPrize1 &&
          data.prizeList1.length > data.prizeList.length &&
          data.y1Circle < data.playDefaultCircle - 1
        ) {
          data.isJoinPrize1 = false
          data.prizeList1 = [...data.prizeList1.slice(0, -1)]
        }

        if (nVal[1] >= minY && nVal[1] <= maxY && !data.isJoinPrize2) {
          data.prizeList2 = [...data.prizeList2, data.prizeList2[0]]
          data.isJoinPrize2 = true
        } else if (
          (nVal[1] < minY || nVal[1] > maxY) &&
          data.isJoinPrize2 &&
          data.prizeList2.length > data.prizeList.length &&
          data.y2Circle < data.playDefaultCircle - 1
        ) {
          data.isJoinPrize2 = false
          data.prizeList2 = [...data.prizeList2.slice(0, -1)]
        }

        if (nVal[2] >= minY && nVal[2] <= maxY && !data.isJoinPrize3) {
          data.prizeList3 = [...data.prizeList3, data.prizeList3[0]]
          data.isJoinPrize3 = true
        } else if (
          (nVal[2] < minY || nVal[2] > maxY) &&
          data.isJoinPrize3 &&
          data.prizeList3.length > data.prizeList.length &&
          data.y3Circle < data.playDefaultCircle - 1
        ) {
          data.isJoinPrize3 = false
          data.prizeList3 = [...data.prizeList3.slice(0, -1)]
        }
      },
    )
    const methods = {
      // 判断不同环境下否游戏是否已登录且为非首次参与
      judgeGameStatus() {
        let cookiePhoneObj: any = getXunJiaInfo3Cookie()
        if (data.browserEnv === 1) {
          if (store.state.appPhone && !data.gameInfo.played) {
            return true
          } else {
            return false
          }
        } else {
          if (
            cookiePhoneObj &&
            cookiePhoneObj.phone &&
            cookiePhoneObj.encryptPhone &&
            !data.gameInfo.played
          ) {
            return true
          } else {
            return false
          }
        }
      },
      // 增加分享机会
      async addDrawTimes() {
        let phone = ''
        if (data.browserEnv === 1) {
          phone = store.state.appEncryptPhone
        } else {
          let cookiePhoneObj: any = getXunJiaInfo3Cookie()
          phone = cookiePhoneObj.encryptPhone
        }

        const res: any = await fetchAddDrawTimes({ phone: phone }) // 增加分享次数
        if (res.code === 200) {
          if (res.data.code === 0) {
            store.dispatch('getGameInfo', {
              actId: route.query.actId,
              phone: phone,
            }) // 更新游戏信息
          }
          setTimeout(
            () => {
              Toast(res.data.msg)
            },
            data.browserEnv === 1 ? 2000 : 20,
          )
        } else {
          Toast(res.messsage)
        }
      },
      // 处理转发
      handleForward() {
        countAd(6560)
        if (methods.judgeGameStatus()) {
          if (data.browserEnv === 1) {
            // app  (ios中，链接isActivity=1会执行window.appShare,android不需要兼容)
            window.location.href = `pcaction://user-share`
          } else {
            // wap
            data.shareCon =
              '天天抽奖，瓜分百万现金，海量购车优惠等着你~点击链接即可参与' +
              '\n' +
              window.location.href
            data.isShowTmForWardPopup = true
          }
        } else {
          // 未登录
          methods.handleLogin()
          return
        }
      },
      // 控制转发弹窗
      toggleTmForWardPopup(obj: any) {
        data.isShowTmForWardPopup = obj.isShowTmForWardPopup
      },
      //  控制领取红包弹窗
      toggleTmReceiveRedPacketPopup(obj: any) {
        data.isShowReceiveRedPacketPopup = obj.isShowReceiveRedPacketPopup
      },
      // 控制领取成功弹窗
      toggleTmReceiveSuccessPopup(obj: any) {
        data.isShowTmReceiveSuccessPopup = obj.isShowTmReceiveSuccessPopup
      },
      // 控制老虎机登录弹窗
      toggleTmLoginPopup(obj: any) {
        data.isShowTmLoginPopup = obj.isShowTmLoginPopup
      },
      // 控制老虎机规则弹窗
      toggleTmRulePopup(obj: any) {
        data.isShowTmRulePopup = obj.isShowTmRulePopup
      },
      /**
       * 开始抽奖
       */
      async startPlay() {
        data.idxs = [0, 0, 0]
        let cookiePhoneObj: any = getXunJiaInfo3Cookie()
        // 抽奖
        const lotteryRes: any = await fetchDrawLottery({
          actId: route.query.actId,
          phone:
            data.browserEnv === 1
              ? store.state.appEncryptPhone
              : cookiePhoneObj.encryptPhone,
        })
        if (lotteryRes.code === 200) {
          if (lotteryRes.data.code === 0) {
            // 中奖 :默认为随机红包索引
            data.idxs = [2, 2, 2]
            methods.initDrawData()
            methods.playAnimation(data.idxs[0], data.idxs[1], data.idxs[2]) // 播放抽奖动画
          } else if (lotteryRes.data.code === 3) {
            // 未中奖
            methods.initDrawData()
            data.idxs = methods.GetRandomArr(0, data.prizeList.length - 1)
            methods.playAnimation(data.idxs[0], data.idxs[1], data.idxs[2])
          } else {
            // 其他情况
            data.isDrawing = false
            Toast(lotteryRes.data.msg)
          }
          // 更新用户的抽奖信息 (剩余机会)
          store.dispatch('getGameInfo', {
            actId: route.query.actId,
            phone:
              data.browserEnv === 1
                ? store.state.appEncryptPhone
                : cookiePhoneObj.encryptPhone,
          })
          data.lotteryResultBO = lotteryRes.data
        } else {
          Toast(lotteryRes.messsage)
        }
      },
      completeCallBack() {
        data.isDrawing = false
        // 提示用户中奖结果
        if (data.lotteryResultBO.code === 0) {
          Toast(data.lotteryResultBO.msg)
          methods.toggleTmReceiveRedPacketPopup({
            isShowReceiveRedPacketPopup: true,
          })
        } else if (data.lotteryResultBO.code === 3) {
          Toast(data.lotteryResultBO.msg)
        }
      },
      // 抽奖动画结束执行回调 (setInterVal)
      completeCallBack1() {
        data.overTimer = setTimeout(() => {
          clearInterval(data.timer1)
          clearInterval(data.timer2)
          clearInterval(data.timer3)
          data.isDrawing = false
          // 提示用户中奖结果
          if (data.lotteryResultBO.code === 0) {
            Toast(data.lotteryResultBO.msg)
            methods.toggleTmReceiveRedPacketPopup({
              isShowReceiveRedPacketPopup: true,
            })
          } else if (data.lotteryResultBO.code === 3) {
            Toast(data.lotteryResultBO.msg)
          }
          if (data.overTimer) {
            clearTimeout(data.overTimer)
            data.overTimer = null
          }
        }, 500)
      },
      // 播放动画  (requestAnimation方案 还是有点卡)
      playAnimation(idx1: any, idx2: any, idx3: any) {
        const circleLength = data.height * data.prizeList.length // 总距离
        const idx1EndDistance = idx1 === 0 ? circleLength : idx1 * data.height // 结束距离1
        const idx2EndDistance = idx2 === 0 ? circleLength : idx2 * data.height // 结束距离2
        const idx3EndDistance = idx3 === 0 ? circleLength : idx3 * data.height // 结束距离3
        let rqAf1: any = null
        let rqAf2: any = null
        let rqAf3: any = null
        // 动画1
        function animation1() {
          // 快速偏移
          if (data.y1Circle < data.playDefaultCircle) {
            data.y1 -= data.speed1
            // 走完一圈
            if (Math.abs(data.y1) >= circleLength) {
              data.y1 += circleLength // 偏移距离变为初始值
              data.y1Circle++
              if (data.speed1 > 0.8) {
                data.speed1 -= 0.4
              }
            }
            // 慢速偏移
          } else {
            if (Math.abs(data.y1) < idx1EndDistance) {
              data.y1 -= data.speed1
            } else {
              data.y1 = -idx1EndDistance
              data.isOver1 = true
              if (data.isOver1 && data.isOver2 && data.isOver3) {
                setTimeout(() => {
                  methods.completeCallBack()
                }, 500)
              }
            }
          }
          if (!data.isOver1) {
            window.requestAnimationFrame(animation1)
          } else {
            window.cancelAnimationFrame(rqAf1)
          }
        }
        rqAf1 = window.requestAnimationFrame(animation1)

        // 动画2
        function animation2() {
          if (data.y2Circle < data.playDefaultCircle) {
            data.y2 -= data.speed2
            if (Math.abs(data.y2) >= circleLength) {
              data.y2 += circleLength
              data.y2Circle++
              if (data.speed2 > 0.8) {
                data.speed2 -= 0.45
              }
            }
          } else {
            if (Math.abs(data.y2) < idx2EndDistance) {
              data.y2 -= data.speed2
            } else {
              data.y2 = -idx2EndDistance
              data.isOver2 = true
              if (data.isOver1 && data.isOver2 && data.isOver3) {
                setTimeout(() => {
                  methods.completeCallBack()
                }, 500)
              }
            }
          }
          if (!data.isOver2) {
            window.requestAnimationFrame(animation2)
          } else {
            window.cancelAnimationFrame(rqAf2)
          }
        }
        data.timer22 && clearTimeout(data.timer22)
        data.timer22 = setTimeout(() => {
          rqAf2 = window.requestAnimationFrame(animation2)
        }, 400)

        // 动画3
        function animation3() {
          if (data.y3Circle < data.playDefaultCircle) {
            data.y3 -= data.speed3
            if (Math.abs(data.y3) >= circleLength) {
              data.y3 += circleLength
              data.y3Circle++
              if (data.speed3 > 0.8) {
                data.speed3 -= 0.5
              }
            }
          } else {
            if (Math.abs(data.y3) < idx3EndDistance) {
              data.y3 -= data.speed3
            } else {
              data.y3 = -idx3EndDistance
              data.isOver3 = true
              if (data.isOver1 && data.isOver2 && data.isOver3) {
                setTimeout(() => {
                  methods.completeCallBack()
                }, 500)
              }
            }
          }
          if (!data.isOver3) {
            window.requestAnimationFrame(animation3)
          } else {
            window.cancelAnimationFrame(rqAf3)
          }
        }
        data.timer33 && clearTimeout(data.timer33)
        data.timer33 = setTimeout(() => {
          rqAf3 = window.requestAnimationFrame(animation3)
        }, 800)
      },
      // 播放动画 (setInterVal太捞了 )
      playAnimation2(idx1: any, idx2: any, idx3: any) {
        const circleLength = data.height * data.prizeList.length // 总距离
        const idx1EndDistance = idx1 === 0 ? circleLength : idx1 * data.height // 结束距离1
        const idx2EndDistance = idx2 === 0 ? circleLength : idx2 * data.height // 结束距离2
        const idx3EndDistance = idx3 === 0 ? circleLength : idx3 * data.height // 结束距离3
        data.timer1 && clearInterval(data.timer1)
        data.timer1 = setInterval(() => {
          // 快速偏移
          if (data.y1Circle < data.playDefaultCircle) {
            data.y1 -= data.speed1
            if (Math.abs(data.y1) >= circleLength) {
              // 走完一圈
              data.y1 += circleLength // 偏移距离变为初始值
              data.y1Circle++
              if (data.speed1 > 0.4) {
                data.speed1 -= 0.15
              }
            }
            // 慢速偏移
          } else {
            if (Math.abs(data.y1) < idx1EndDistance) {
              data.y1 -= data.slowSpeed
            } else {
              data.y1 = -idx1EndDistance
              // 索引为0的情况长度最长， 需等待该动画执行完毕再执行回调
              // 索引不为0的情况，索引值最大则长度最长，则在该动画执行完后才执行回调
              if (idx1 === 0 && !data.overTimer) {
                methods.completeCallBack()
              } else if (
                idx1 > idx2 &&
                idx1 > idx3 &&
                idx2 !== 0 &&
                idx3 !== 0 &&
                !data.overTimer
              ) {
                methods.completeCallBack()
              }
            }
          }
        }, 1 / 12)
        data.timer22 && clearTimeout(data.timer22)
        data.timer22 = setTimeout(() => {
          data.timer2 && clearInterval(data.timer2)
          data.timer2 = setInterval(() => {
            if (data.y2Circle < data.playDefaultCircle) {
              data.y2 -= data.speed2
              if (Math.abs(data.y2) >= circleLength) {
                data.y2 += circleLength
                data.y2Circle++
                if (data.speed2 > 0.4) {
                  data.speed2 -= 0.16
                }
              }
            } else {
              if (Math.abs(data.y2) < idx2EndDistance) {
                data.y2 -= data.slowSpeed
              } else {
                data.y2 = -idx2EndDistance
                if (idx2 === 0 && !data.overTimer) {
                  methods.completeCallBack()
                } else if (
                  idx2 > idx1 &&
                  idx2 > idx3 &&
                  idx1 !== 0 &&
                  idx3 !== 0 &&
                  !data.overTimer
                ) {
                  methods.completeCallBack()
                }
              }
            }
          }, 1 / 12)
        }, 500)
        data.timer33 && clearTimeout(data.timer33)
        data.timer33 = setTimeout(() => {
          data.timer3 && clearInterval(data.timer3)
          data.timer3 = setInterval(() => {
            if (data.y3Circle < data.playDefaultCircle) {
              data.y3 -= data.speed3
              if (Math.abs(data.y3) >= circleLength) {
                data.y3 += circleLength
                data.y3Circle++
                if (data.speed3 > 0.4) {
                  data.speed3 -= 0.17
                }
              }
            } else {
              if (idx3 === 0 && data.isJoinPrize === false) {
                store.commit('setPrizeList', [
                  ...data.prizeList,
                  data.prizeList[0],
                ])
                data.isJoinPrize = true
              }
              if (Math.abs(data.y3) < idx3EndDistance) {
                data.y3 -= data.slowSpeed
              } else {
                data.y3 = -idx3EndDistance
                // 重复代码
                if (idx3 === 0 && !data.overTimer) {
                  methods.completeCallBack()
                } else if (
                  idx3 > idx2 &&
                  idx3 > idx1 &&
                  idx1 !== 0 &&
                  idx2 !== 0 &&
                  !data.overTimer
                ) {
                  methods.completeCallBack()
                } else if (idx3 === idx2 && idx3 === idx1 && !data.overTimer) {
                  methods.completeCallBack()
                }
              }
            }
          }, 1 / 12)
        }, 800)
      },
      // 播放动画 (setInterVal方案 太捞了)
      playAnimation1(idx1: any, idx2: any, idx3: any) {
        const circleLength = data.height * data.prizeList.length // 总距离
        const idx1EndDistance = idx1 === 0 ? circleLength : idx1 * data.height // 结束距离1
        const idx2EndDistance = idx2 === 0 ? circleLength : idx2 * data.height // 结束距离2
        const idx3EndDistance = idx3 === 0 ? circleLength : idx3 * data.height // 结束距离3
        data.timer1 && clearInterval(data.timer1)
        data.timer1 = setInterval(() => {
          // 快速偏移
          if (data.y1Circle < data.playDefaultCircle) {
            data.y1 -= data.speed1
            if (Math.abs(data.y1) >= circleLength) {
              data.y1 += circleLength // 偏移距离变为初始值
              data.y1Circle++
              if (data.speed1 > 0.4) {
                data.speed1 -= 0.2
              }
            }
            // 慢速偏移
          } else {
            // 中奖索引为0，慢速滚动会出现空白奖品(且只能偏移内的长度)
            if (idx1 === 0 && data.isJoinPrize1 === false) {
              store.commit('setPrizeList', [
                ...data.prizeList,
                data.prizeList[0],
              ])
              data.isJoinPrize1 = true
            }

            if (Math.abs(data.y1) < idx1EndDistance) {
              data.y1 -= data.slowSpeed
            } else {
              data.y1 = -idx1EndDistance
              // 索引为0的情况长度最长， 需等待该动画执行完毕再执行回调
              // 索引不为0的情况，索引值最大则长度最长，则在该动画执行完后才执行回调
              if (idx1 === 0 && !data.overTimer) {
                methods.completeCallBack()
              } else if (
                idx1 > idx2 &&
                idx1 > idx3 &&
                idx2 !== 0 &&
                idx3 !== 0 &&
                !data.overTimer
              ) {
                methods.completeCallBack()
              }
            }
          }
        }, 0)
        data.timer22 && clearTimeout(data.timer22)
        data.timer22 = setTimeout(() => {
          data.timer2 && clearInterval(data.timer2)
          data.timer2 = setInterval(() => {
            if (data.y2Circle < data.playDefaultCircle) {
              data.y2 -= data.speed
              if (Math.abs(data.y2) >= circleLength) {
                data.y2 += circleLength
                data.y2Circle++
              }
            } else {
              if (idx2 === 0 && data.isJoinPrize === false) {
                store.commit('setPrizeList', [
                  ...data.prizeList,
                  data.prizeList[0],
                ])
                data.isJoinPrize = true
              }
              if (Math.abs(data.y2) < idx2EndDistance) {
                data.y2 -= data.slowSpeed
              } else {
                data.y2 = -idx2EndDistance
                if (idx2 === 0 && !data.overTimer) {
                  methods.completeCallBack()
                } else if (
                  idx2 > idx1 &&
                  idx2 > idx3 &&
                  idx1 !== 0 &&
                  idx3 !== 0 &&
                  !data.overTimer
                ) {
                  methods.completeCallBack()
                }
              }
            }
          }, 0)
        }, 500)
        data.timer33 && clearTimeout(data.timer33)
        data.timer33 = setTimeout(() => {
          data.timer3 && clearInterval(data.timer3)
          data.timer3 = setInterval(() => {
            if (data.y3Circle < data.playDefaultCircle) {
              data.y3 -= data.speed
              if (Math.abs(data.y3) >= circleLength) {
                data.y3 += circleLength
                data.y3Circle++
              }
            } else {
              if (idx3 === 0 && data.isJoinPrize === false) {
                store.commit('setPrizeList', [
                  ...data.prizeList,
                  data.prizeList[0],
                ])
                data.isJoinPrize = true
              }
              if (Math.abs(data.y3) < idx3EndDistance) {
                data.y3 -= data.slowSpeed
              } else {
                data.y3 = -idx3EndDistance
                // 重复代码
                if (idx3 === 0 && !data.overTimer) {
                  methods.completeCallBack()
                } else if (
                  idx3 > idx2 &&
                  idx3 > idx1 &&
                  idx1 !== 0 &&
                  idx2 !== 0 &&
                  !data.overTimer
                ) {
                  methods.completeCallBack()
                } else if (idx3 === idx2 && idx3 === idx1 && !data.overTimer) {
                  methods.completeCallBack()
                }
              }
            }
          }, 0)
        }, 800)
      },
      // 随机分配索引 （后两个索引必须与第一个不同）
      GetRandomArr(min: number, max: number) {
        let arr: number[] = []
        let Random = 1
        for (let i = 0; i < 3; i++) {
          getLuckyNum()
        }
        function getLuckyNum() {
          do {
            Random = Math.floor(Math.random() * (max - min + 1) + min)
          } while (arr[0] === Random)
          arr.push(Random)
        }
        return arr
      },
      // 获取奖品index
      getPrizeIndex() {
        data.prizeList.some((item: any, index: any) => {
          if (item.id === data.lotteryResult.id) {
            data.prizeIndex = index
            return true
          }
        })
      },
      // 初始化动画数据 (requestAnimation方案 还是有点卡)
      initDrawData() {
        data.prizeList1 = [...data.prizeList]
        data.prizeList2 = [...data.prizeList]
        data.prizeList3 = [...data.prizeList]
        data.height = 29.33
        data.prizeIndex = -1
        data.speed = 3
        data.speed1 = 3
        data.speed2 = 3
        data.speed3 = 3
        data.playDefaultCircle = 6
        data.y1Circle = 0
        data.y2Circle = 0
        data.y3Circle = 0
        data.timer1 = null
        data.timer2 = null
        data.timer3 = null
        data.isJoinPrize = false
        data.isJoinPrize1 = false
        data.isJoinPrize2 = false
        data.isJoinPrize3 = false
        data.isOver1 = false
        data.isOver2 = false
        data.isOver3 = false
      },
      // 初始化动画数据 (setInterVal方案 太捞了)
      initDrawData1() {
        data.prizeList1 = [...data.prizeList]
        data.prizeList2 = [...data.prizeList]
        data.prizeList3 = [...data.prizeList]
        data.height = 29.33
        data.prizeIndex = -1
        data.speed = 1
        data.speed1 = 1
        data.speed2 = 1
        data.speed3 = 1
        data.slowSpeed = 0.3
        data.playDefaultCircle = 6
        data.y1Circle = 0
        data.y2Circle = 0
        data.y3Circle = 0
        data.timer1 = null
        data.timer2 = null
        data.timer3 = null
        data.isJoinPrize = false
        data.isJoinPrize1 = false
        data.isJoinPrize2 = false
        data.isJoinPrize3 = false
      },
      // 点击抽奖
      handleDrawLottery() {
        countAd(6559)
        if (data.isDrawing) {
          Toast('正在抽奖，请勿重复点击')
          return
        }
        // 已登录且非首次
        if (methods.judgeGameStatus()) {
          // 有机会
          if (data.gameInfo.remainPlayCount > 0) {
            data.isDrawing = true
            methods.startPlay()
            return
          } else {
            Toast('您的次数已用完，可转发好友获得更多次数！')
            return
          }
        } else {
          // 未登录
          methods.handleLogin()
          return
        }
      },
      // 登录处理
      handleLogin() {
        if (data.browserEnv === 1) {
          window.location.href = 'pcaction://user-login/?callback=appCallback'
        } else {
          methods.toggleTmLoginPopup({ isShowTmLoginPopup: true })
        }
      },
      // 监听剪贴板
      listenClipBoard() {
        data.clipboard.on('success', () => {
          console.log('粘贴成功')
        })
      },
      // 获取当前用户游戏详情
      // 获取奖品列表（目前奖品不可配置)
      getPrizeList() {
        // 3元现金、5元现金、随机红包、购车补贴、1元现金、8元现金 175*144
        let prizeList: any[] = [
          {
            id: 1,
            name: '3元现金',
            img: require('../../assets/icons/3-yuan-icon.png'),
          },
          {
            id: 2,
            name: '5元现金',
            img: require('../../assets/icons/5-yuan-icon.png'),
          },
          {
            id: 3,
            name: '随机红包',
            img: require('../../assets/icons/random-money-icon.png'),
          },
          {
            id: 4,
            name: '购车补贴',
            img: require('../../assets/icons/subsidy-icon.png'),
          },
          {
            id: 5,
            name: '1元现金',
            img: require('../../assets/icons/1-yuan-icon.png'),
          },
          {
            id: 6,
            name: '8元现金',
            img: require('../../assets/icons/8-yuan-icon.png'),
          },
        ]
        data.prizeList1 = [...prizeList]
        data.prizeList2 = [...prizeList]
        data.prizeList3 = [...prizeList]
        store.commit('setPrizeList', prizeList)
      },
    }
    onMounted(() => {
      methods.listenClipBoard()
      methods.getPrizeList()
      // 分享成功执行的回调
      window.appShare = function () {
        methods.addDrawTimes()
      }
    })
    return {
      ...methods,
      ...toRefs(data),
    }
  },
})
